/* ============================================================
   atlas-runtime.js
   BUILD ARTIFACT -- regenerated for the V5.6 freeze. Do not hand-edit.
   Edit the source file listed below, then rebuild.

   Concatenated IN CASCADE ORDER from, and only from:
      1. atlas-v5.js
      2. atlas-v51.js
      3. atlas-v54.js
      4. atlas-v56.js

   Every source file is still in the theme, unlinked, and remains the editable
   original -- that is where the reasoning for each rule lives. Shopify strips
   comments when it serves an asset, so nothing is lost here that the browser
   was ever going to receive.

   Assets load ONCE per page: snippets/atlas-assets.liquid is rendered by
   atlas-header only. It used to be rendered by atlas-announcement as well,
   which is why Home once requested 41 stylesheets with 19 duplicates.
   ============================================================ */
/* Shared runtime. Each source is a self-contained IIFE, so concatenation cannot leak scope; each returns early when its root element is absent, which keeps the Home runtime inert on the PDP and vice versa. atlas-v56.js carries the compression steps, the anatomy hotspots and the Add to Bag states -- the compression section no longer ships an inline script. */

/* ---------- atlas-v5.js ---------- */
(function(){"use strict";var reduce=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches,$=function(s,r){return(r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};function inView(sel,cls){var els=$$(sel);if(els.length){var show=function(el){el.classList.add(cls)};if(reduce||!("IntersectionObserver"in window)){els.forEach(show);return}var io=new IntersectionObserver(function(es){es.forEach(function(e){e.isIntersecting&&(show(e.target),io.unobserve(e.target))})},{rootMargin:"0px 0px -12% 0px",threshold:.12});els.forEach(function(el){io.observe(el)}),setTimeout(function(){els.forEach(show),io.disconnect()},2500)}}inView(".dt5__card","is-in"),inView(".sp5__lead","is-in"),$$(".sp5").forEach(function(root){var tabs=$$(".sp5__tab",root),imgs=$$(".sp5__stage img",root);if(tabs.length<2||tabs.length!==imgs.length)return;function pick(i){tabs.forEach(function(t,n){t.setAttribute("aria-selected",n===i?"true":"false")}),imgs.forEach(function(m,n){m.classList.toggle("is-on",n===i)})}tabs.forEach(function(t,i){t.addEventListener("click",function(){pick(i)}),t.addEventListener("keydown",function(e){var d=e.key==="ArrowRight"?1:e.key==="ArrowLeft"?-1:0;if(d){e.preventDefault();var n=(i+d+tabs.length)%tabs.length;tabs[n].focus(),pick(n)}})}),pick(0)}),$$(".og5").forEach(function(root){var pins=$$(".og5__pin",root),btns=$$(".og5__btn",root),cap=$(".og5__cap",root);if(!pins.length||pins.length!==btns.length)return;function pick(i){pins.forEach(function(p,n){p.setAttribute("aria-selected",n===i?"true":"false")}),btns.forEach(function(b,n){b.setAttribute("aria-selected",n===i?"true":"false")}),cap&&(cap.textContent=btns[i].getAttribute("data-note")||"")}pins.concat(btns).forEach(function(el,n){el.addEventListener("click",function(){pick(n%pins.length)})}),pick(0)}),$$(".rv5").forEach(function(root){var rail=$(".rv5__rail",root),prev=$('[data-rv="prev"]',root),next=$('[data-rv="next"]',root);if(!rail||!prev||!next)return;function step(){var c=rail.firstElementChild;return c?c.getBoundingClientRect().width+16:320}function sync(){prev.disabled=rail.scrollLeft<8,next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8}prev.addEventListener("click",function(){rail.scrollBy({left:-step(),behavior:reduce?"auto":"smooth"})}),next.addEventListener("click",function(){rail.scrollBy({left:step(),behavior:reduce?"auto":"smooth"})}),rail.addEventListener("scroll",sync,{passive:!0}),window.addEventListener("resize",sync),sync()});var stage=$(".hero5__stage"),fine=window.matchMedia&&matchMedia("(hover: hover) and (pointer: fine)").matches;if(stage&&fine&&!reduce){var hero=stage.closest(".hero5"),raf=0,tx=0,ty=0;hero.addEventListener("pointermove",function(e){var r=hero.getBoundingClientRect();tx=((e.clientX-r.left)/r.width-.5)*2,ty=((e.clientY-r.top)/r.height-.5)*2,!raf&&(raf=requestAnimationFrame(function(){raf=0,stage.style.transform="perspective(1200px) rotateY("+(tx*3).toFixed(2)+"deg) rotateX("+(-ty*2).toFixed(2)+"deg)"}))}),hero.addEventListener("pointerleave",function(){stage.style.transform=""})}})();
//# sourceMappingURL=/cdn/shop/t/12/assets/atlas-v5.js.map

/* ---------- atlas-v51.js ---------- */
(function(){"use strict";var reduce=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches,$=function(s,r){return(r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};(function(){var hero=$(".hero51");if(!hero)return;var imgs=$$(".hero51__img",hero),thumbs=$$(".hero51__thumb",hero);if(imgs.length<2||thumbs.length!==imgs.length)return;function pick(i){imgs.forEach(function(m,n){m.classList.toggle("is-on",n===i)}),thumbs.forEach(function(t,n){t.classList.toggle("is-on",n===i),t.setAttribute("aria-selected",n===i?"true":"false")})}thumbs.forEach(function(t,i){t.addEventListener("click",function(){pick(i)}),t.addEventListener("keydown",function(e){var d=e.key==="ArrowRight"||e.key==="ArrowDown"?1:e.key==="ArrowLeft"||e.key==="ArrowUp"?-1:0;if(d){e.preventDefault();var n=(i+d+thumbs.length)%thumbs.length;thumbs[n].focus(),pick(n)}})}),pick(0)})(),$$(".an5").forEach(function(root){var btns=$$(".an5__pt",root),cards=$$(".an5__card",root);if(!btns.length)return;function pick(i){btns.forEach(function(b,n){b.setAttribute("aria-selected",n===i?"true":"false")}),cards.forEach(function(c,n){c.setAttribute("aria-selected",n===i?"true":"false")})}btns.concat(cards).forEach(function(el,n){el.addEventListener("click",function(){pick(n%btns.length)}),el.addEventListener("focus",function(){pick(n%btns.length)})}),pick(0)}),$$(".cr5").forEach(function(root){var rail=$(".cr5__rail",root),prev=$('[data-cr="prev"]',root),next=$('[data-cr="next"]',root),fill=$(".cr5__fill",root),live=$("[data-cr-live]",root);if(!rail)return;var cards=$$(".cr5__card",rail);function step(){var c=rail.firstElementChild;return c?c.getBoundingClientRect().width+16:340}function sync(){var max=rail.scrollWidth-rail.clientWidth,p=max>4?rail.scrollLeft/max:1;if(fill&&(fill.style.transform="scaleX("+Math.max(.12,Math.min(1,p)).toFixed(3)+")"),prev&&(prev.disabled=rail.scrollLeft<8),next&&(next.disabled=rail.scrollLeft>=max-8),live&&cards.length){var i=Math.round(rail.scrollLeft/step())+1;live.textContent="Review "+Math.min(i,cards.length)+" of "+cards.length}}prev&&prev.addEventListener("click",function(){rail.scrollBy({left:-step(),behavior:reduce?"auto":"smooth"})}),next&&next.addEventListener("click",function(){rail.scrollBy({left:step(),behavior:reduce?"auto":"smooth"})}),rail.addEventListener("scroll",sync,{passive:!0}),window.addEventListener("resize",sync),sync()}),$$(".nl5__form").forEach(function(form){form.addEventListener("submit",function(){var b=$("button",form);b&&(b.disabled=!0,b.textContent="Joining\u2026")})})})();
//# sourceMappingURL=/cdn/shop/t/12/assets/atlas-v51.js.map

/* ---------- atlas-v54.js ---------- */
(function(){"use strict";var reduce=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;if(reduce)return;var header=document.querySelector("[data-atlas-header]"),camp=document.querySelector(".sp51__objs"),campSec=document.querySelector(".sp51");if(!header&&!camp)return;var TRAVEL=64,compact=!1,ticking=!1;function frame(){if(ticking=!1,header){var want=window.scrollY>60;want!==compact&&(compact=want,header.classList.toggle("at-hd--compact",want))}if(camp&&campSec&&window.innerWidth>=900){var r=campSec.getBoundingClientRect(),vh=window.innerHeight,p=(vh-r.top)/(vh*.85);p=p<0?0:p>1?1:p,camp.style.setProperty("--sp51-x",((1-p)*TRAVEL).toFixed(1)+"px")}}function onScroll(){ticking||(ticking=!0,window.requestAnimationFrame(frame))}window.addEventListener("scroll",onScroll,{passive:!0}),window.addEventListener("resize",onScroll,{passive:!0}),frame()})();
//# sourceMappingURL=/cdn/shop/t/12/assets/atlas-v54.js.map

/* ---------- atlas-v56.js ---------- */
/* ============================================================
   ATLAS V5.6 — interaction runtime. Frozen.

   Three things, all promised by the markup and not delivered:
     1. Compression  five dead <button>s -> a real step sequence
     2. Anatomy      six half-buttons -> hotspots that write one panel
     3. Add to Bag   no feedback -> ADDING... / ADDED, and no double submit

   RULES THIS FILE KEEPS
   - State lives in ONE place: aria-selected. Every style in the CSS hangs off
     [aria-selected="true"]. The previous compression script set aria-current
     while the stylesheet waited for an .is-on class, so clicking a step
     changed nothing at all. Do not add a parallel class.
   - Nothing here HIDES content. If this file never loads, both sections read
     as a photograph plus a full list, and Add to Bag is a normal form submit.
   - No library, no observer gating content. The only observer is a one-shot
     marker breath that disconnects itself.
   ============================================================ */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function slice(n) { return Array.prototype.slice.call(n); }

  /* Roving tabindex: arrows move, Home/End jump, only the active tab is a
     tab stop. Shared by both sections so their keyboard model is identical. */
  function wireTabs(tabs, pick) {
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(i, true); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        if (n === null) return;
        e.preventDefault();
        pick(n, true);
        tabs[n].focus();
      });
    });
  }
  function markTabs(tabs, i) {
    tabs.forEach(function (t, n) {
      var on = n === i;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
  }

  /* ----------------------------------------------------------
     1. COMPRESSION
     Selecting a step frames the part of the ONE authentic photograph that the
     step is about: scale 1.06 around a per-step origin. Step 01 sits at 1.0
     because it is the establishing view of the whole bag.
     This is editorial framing, NOT a simulation of volume dropping. Nothing
     here should ever be made to look like the bag shrinking.
     ---------------------------------------------------------- */
  (function compression() {
    var root = document.querySelector('[data-cm]');
    if (!root) return;
    var steps = slice(root.querySelectorAll('[data-cm-step]'));
    var pins  = slice(root.querySelectorAll('[data-cm-pin]'));
    var photo = root.querySelector('.cm52__photo');
    var fill  = root.querySelector('.cm52__fill');
    var now   = root.querySelector('[data-cm-now]');
    if (!steps.length) return;

    function pick(i) {
      markTabs(steps, i);
      pins.forEach(function (p, n) { p.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      if (photo && !REDUCE) {
        var s = steps[i];
        photo.style.transformOrigin = s.dataset.fx + '% ' + s.dataset.fy + '%';
        photo.style.transform = 'scale(' + (s.dataset.zoom || 1) + ')';
      }
      if (fill) fill.style.transform = 'scaleX(' + ((i + 1) / steps.length) + ')';
      if (now) now.textContent = String(i + 1);
    }
    wireTabs(steps, pick);

    /* On a phone the steps are a horizontal snap rail; keep the selection in
       step with whatever the thumb actually stopped on. */
    var rail = root.querySelector('.cm52__steps');
    if (rail) {
      var t;
      rail.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (rail.scrollWidth <= rail.clientWidth + 4) return;
          var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, dist = 1e9;
          steps.forEach(function (s, n) {
            var c = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(c - mid);
            if (d < dist) { dist = d; best = n; }
          });
          pick(best);
        }, 90);
      }, { passive: true });
    }
    pick(0);
  })();

  /* ----------------------------------------------------------
     2. ANATOMY
     The ring (desktop) and the card rail (mobile) are two views of ONE
     selection, and both write the same panel. Copy is read out of the cards,
     so it exists once in the DOM and cannot drift.
     ---------------------------------------------------------- */
  (function anatomy() {
    var root = document.querySelector('[data-an]');
    if (!root) return;
    var pts   = slice(root.querySelectorAll('[data-an-pt]'));
    var cards = slice(root.querySelectorAll('[data-an-card]'));
    var title = root.querySelector('[data-an-title]');
    var desc  = root.querySelector('[data-an-desc]');
    var num   = root.querySelector('[data-an-now]');
    var panel = root.querySelector('.an5__panel');
    if (!pts.length || !cards.length) return;

    var data = cards.map(function (c) {
      return { t: (c.querySelector('b') || {}).textContent || '',
               d: (c.querySelector('span') || {}).textContent || '' };
    });

    var current = -1;
    function pick(i, focusCard) {
      if (i === current) return;
      current = i;
      markTabs(pts, i);
      markTabs(cards, i);
      if (title) title.textContent = data[i].t;
      if (desc)  desc.textContent  = data[i].d;
      if (num)   num.textContent   = ('0' + (i + 1)).slice(-2);
      if (panel && !REDUCE) {
        /* Retrigger the panel's swap animation without a class toggle race. */
        panel.style.animation = 'none';
        void panel.offsetWidth;
        panel.style.animation = '';
      }
      if (focusCard && cards[i] && cards[i].scrollIntoView) {
        cards[i].scrollIntoView({ inline: 'center', block: 'nearest',
                                  behavior: REDUCE ? 'auto' : 'smooth' });
      }
    }
    wireTabs(pts, function (i) { pick(i, true); });
    wireTabs(cards, function (i) { pick(i, false); });

    /* Escape returns to the opening state rather than trapping the reader on
       whichever detail they happened to open last. */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current !== 0) { pick(0, true); pts[0].focus(); }
    });

    pick(0, false);

    /* ONE breath when the section first arrives, then the observer is gone.
       Nothing is hidden while waiting for it: the markers are already at rest
       and this only adds a single transient class. */
    if (!REDUCE && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          root.classList.add('an5--breathe');
          setTimeout(function () { root.classList.remove('an5--breathe'); }, 1400);
          io.disconnect();
        });
      }, { threshold: 0.35 });
      io.observe(root);
    }
  })();

  /* ----------------------------------------------------------
     3. ADD TO BAG feedback
     The button used to submit silently, so on a slow connection the only
     signal that anything happened was the drawer appearing some time later --
     which is exactly when people click twice. The label now says what is
     happening, and a guard blocks the second submit.
     The original label is restored so a reader who closes the drawer and
     comes back does not find a button stuck on "ADDED".
     ---------------------------------------------------------- */
  (function addToBag() {
    var forms = slice(document.querySelectorAll('form[action*="/cart/add"]'));
    if (!forms.length) return;
    forms.forEach(function (f) {
      var btn = f.querySelector('button[type="submit"], .at-btn');
      if (!btn) return;
      var busy = false;
      f.addEventListener('submit', function (e) {
        if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        busy = true;
        var original = btn.innerHTML;
        btn.setAttribute('aria-busy', 'true');
        btn.dataset.atcState = 'adding';
        btn.innerHTML = 'Adding…';
        var done = function (ok) {
          btn.dataset.atcState = ok ? 'added' : '';
          if (ok) btn.innerHTML = 'Added to bag';
          setTimeout(function () {
            btn.innerHTML = original;
            btn.removeAttribute('aria-busy');
            delete btn.dataset.atcState;
            busy = false;
          }, ok ? 1500 : 400);
        };
        /* The theme's own cart script owns the request; listen for the drawer
           opening rather than duplicating the fetch. The timeout is the
           failsafe so the button can never be left stuck. */
        var seen = false;
        var check = setInterval(function () {
          var d = document.querySelector('.at-cd');
          if (d && /--on|is-open/.test(d.className)) {
            seen = true; clearInterval(check); done(true);
          }
        }, 120);
        setTimeout(function () { clearInterval(check); if (!seen) done(false); }, 4000);
      }, true);
    });
  })();
})();
